import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'

export interface BirthdayRewardConfig {
  enabled: boolean
  rewardItemId: string | null
}

async function fetchBirthdayRewardConfig(): Promise<BirthdayRewardConfig> {
  const { data, error } = await supabase
    .from('birthday_reward_config')
    .select('enabled, reward_item_id')
    .single()

  if (error) throw error

  return {
    enabled: data.enabled,
    rewardItemId: data.reward_item_id,
  }
}

export function useBirthdayRewardConfigQuery() {
  return useQuery({
    queryKey: ['birthday-reward-config'],
    queryFn: fetchBirthdayRewardConfig,
  })
}
